export default {
  units: "meters",
  radius: 6371008.8
};